<template>
  <calendar-main
    :add-permission="hasAddPermission"
    :delete-permission="hasDeletePermission"
    :edit-permission="hasEditPermission"
    :get-categories="getCategories"
    :get-events="getEvents"
  />
</template>

<script>
import { CalendarMain } from 'operations';
import { fetchEvents, fetchCategory } from '@/modules/operations/api';
import applications from '@/utils/constants/applications.js';

export default {
  name: 'MainEventWrapper',
  components: { CalendarMain },
  computed: {
    hasAddPermission() {
      return this.userHasPermissions('calendar.add');
    },
    hasEditPermission() {
      return this.userHasPermissions('calendar.edit');
    },
    hasDeletePermission() {
      return this.userHasPermissions('calendar.delete');
    },
  },
  methods: {
    getEvents(categoryId) {
      return fetchEvents(categoryId, applications.Provider);
    },
    getCategories() {
      return fetchCategory();
    },
  },
};
</script>
